export default __webpack_public_path__ + "images/0x22d4002028f537599be9f666d1c4fa138522f9c8.png";